import {useWhiteboardStore} from '@modules/whiteboard'
import {React} from '@api'
import {observer, Popover2} from '@api'
import {Button, Menu, MenuItem, MenuItemProps} from '@blueprintjs/core'
import {WhiteboardMenuItem} from '@modules/whiteboard'
import * as css from './ZoomMenu.css'
import {Tooltip} from '@material-ui/core'

export const ZoomMenu = observer(function ZoomMenu() {
  const {camera: {zoom, resetZoom, zoomIn, zoomOut, zoomToFit, zoomToSelection}} = useWhiteboardStore()

  return (
    <Popover2
      interactionKind='click'
      position='bottom'
      content={
        <Menu>
          <WhiteboardMenuItem shouldDismissPopover={false} text={'Zoom In'} kbd='#+' onClick={zoomIn}/>
          <WhiteboardMenuItem shouldDismissPopover={false} text={'Zoom Out'} kbd='#−' onClick={zoomOut}/>
          <WhiteboardMenuItem shouldDismissPopover={false} text={'To 100%'} kbd='⇧0' onClick={resetZoom}/>
          <WhiteboardMenuItem shouldDismissPopover={false} text={'To Fit'} kbd='⇧1' onClick={zoomToFit}/>
          <WhiteboardMenuItem shouldDismissPopover={false} text={'To Selection'} kbd='⇧2' onClick={() => zoomToSelection()}/>
        </Menu>
      }
    >
      <Tooltip title='Zoom Level' placement='bottom'>
        <Button className={css.button} minimal onDoubleClick={resetZoom}>
          {Math.round(zoom * 100)}%
        </Button>
      </Tooltip>
    </Popover2>
  )
})



// WEBPACK FOOTER //
// ./src/modules/whiteboard/components/TopPanel/ZoomMenu/ZoomMenu.tsx